import { render } from "./RoomEdit.vue?vue&type=template&id=12fb47a4&scoped=true"
import script from "./RoomEdit.vue?vue&type=script&lang=js"
export * from "./RoomEdit.vue?vue&type=script&lang=js"

import "./RoomEdit.vue?vue&type=style&index=0&id=12fb47a4&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fb47a4"]])

export default __exports__